import supplementsRootSourceDesktop1 from 'assets/images/landingPages/supplements/d-supplements_rootsource_1_hero.jpg';
import supplementsRootSourceDesktop2 from 'assets/images/landingPages/supplements/d-supplements_rootsource_2_hero.jpg';
import supplementsRootSourceMobile1 from 'assets/images/landingPages/supplements/m-supplements_rootsource_1_hero.jpg';
import supplementsRootSourceMobile2 from 'assets/images/landingPages/supplements/m-supplements_rootsource_2_hero.jpg';
import supplementsBigHandsDesktop from 'assets/images/landingPages/supplements/supplements_big_hands_d.jpg';
import supplementsBigHandsMobile from 'assets/images/landingPages/supplements/supplements_big_hands_m.jpg';
import supplementsBigHandsTablet from 'assets/images/landingPages/supplements/supplements_big_hands_t.jpg';
import supplementsBlog1 from 'assets/images/landingPages/supplements/supplements_blog_1.jpg';
import supplementsBlog2 from 'assets/images/landingPages/supplements/supplements_blog_2.jpg';
import supplementsCapsuleDesktop1 from 'assets/images/landingPages/supplements/supplements_capsule_1_d.jpg';
import supplementsCapsuleMobile1 from 'assets/images/landingPages/supplements/supplements_capsule_1_m.jpg';
import supplementsCapsuleDesktop2 from 'assets/images/landingPages/supplements/supplements_capsule_2_d.jpg';
import supplementsCapsuleMobile2 from 'assets/images/landingPages/supplements/supplements_capsule_2_m.jpg';
import supplementsCapsuleDesktop3 from 'assets/images/landingPages/supplements/supplements_capsule_3_d.jpg';
import supplementsCapsuleMobile3 from 'assets/images/landingPages/supplements/supplements_capsule_3_m.jpg';
import supplementsCapsuleDesktop4 from 'assets/images/landingPages/supplements/supplements_capsule_4_d.jpg';
import supplementsCapsuleMobile4 from 'assets/images/landingPages/supplements/supplements_capsule_4_m.jpg';
import supplementsCapsuleCircle from 'assets/images/landingPages/supplements/supplements_capsule_circle.svg';
import supplementsClinicalDesktop from 'assets/images/landingPages/supplements/supplements_clinical_d.jpg';
import supplementsClinicalMobile from 'assets/images/landingPages/supplements/supplements_clinical_m.jpg';
import supplementsClinicalTablet from 'assets/images/landingPages/supplements/supplements_clinical_t.jpg';
import supplementsCloudyPillDesktop from 'assets/images/landingPages/supplements/supplements_cloudy_pill_d.jpg';
import supplementsCloudyPillMobile from 'assets/images/landingPages/supplements/supplements_cloudy_pill_m.jpg';
import supplementsCloudyPillTablet from 'assets/images/landingPages/supplements/supplements_cloudy_pill_t.jpg';
import supplementsFormulaDesktop from 'assets/images/landingPages/supplements/supplements_formula_d.jpg';
import supplementsFormulaMobile from 'assets/images/landingPages/supplements/supplements_formula_m.jpg';
import supplementsFormulaTablet from 'assets/images/landingPages/supplements/supplements_formula_t.jpg';
import supplementsFullRoutineDesktop from 'assets/images/landingPages/supplements/supplements_full_routine_d.jpg';
import supplementsFullRoutineMobile from 'assets/images/landingPages/supplements/supplements_full_routine_m.jpg';
import supplementsFullRoutineTablet from 'assets/images/landingPages/supplements/supplements_full_routine_t.jpg';
import supplementsHeroDesktop from 'assets/images/landingPages/supplements/supplements_hero_d.jpg';
import supplementsHeroMobile from 'assets/images/landingPages/supplements/supplements_hero_m.jpg';
import supplementsHeroTablet from 'assets/images/landingPages/supplements/supplements_hero_t.jpg';
import supplementsProseLogo from 'assets/images/landingPages/supplements/supplements_prose_logo.svg';
import supplementsScrollingTextDesktop from 'assets/images/landingPages/supplements/supplements_scrolling_text_d.jpg';
import supplementsScrollingTextMobile from 'assets/images/landingPages/supplements/supplements_scrolling_text_m.jpg';
import supplementsScrollingTextTablet from 'assets/images/landingPages/supplements/supplements_scrolling_text_t.jpg';
import supplementsSelector1 from 'assets/images/landingPages/supplements/supplements_selector_1_m.jpg';
import supplementsSelector2 from 'assets/images/landingPages/supplements/supplements_selector_2_m.jpg';
import supplementsSelector3 from 'assets/images/landingPages/supplements/supplements_selector_3_m.jpg';
import supplementsSelectorBackgroundDesktop1 from 'assets/images/landingPages/supplements/supplements_selector_background_1_d.jpg';
import supplementsSelectorBackgroundMobile1 from 'assets/images/landingPages/supplements/supplements_selector_background_1_m.jpg';
import supplementsSelectorBackgroundTablet1 from 'assets/images/landingPages/supplements/supplements_selector_background_1_t.jpg';
import supplementsSelectorBackgroundDesktop2 from 'assets/images/landingPages/supplements/supplements_selector_background_2_d.jpg';
import supplementsSelectorBackgroundMobile2 from 'assets/images/landingPages/supplements/supplements_selector_background_2_m.jpg';
import supplementsSelectorBackgroundTablet2 from 'assets/images/landingPages/supplements/supplements_selector_background_2_t.jpg';
import supplementsSelectorBackgroundDesktop3 from 'assets/images/landingPages/supplements/supplements_selector_background_3_d.jpg';
import supplementsSelectorBackgroundMobile3 from 'assets/images/landingPages/supplements/supplements_selector_background_3_m.jpg';
import supplementsSelectorBackgroundTablet3 from 'assets/images/landingPages/supplements/supplements_selector_background_3_t.jpg';
import supplementsSelectorModelDesktop1 from 'assets/images/landingPages/supplements/supplements_selector_model_1_d.jpg';
import supplementsSelectorModelMobile1 from 'assets/images/landingPages/supplements/supplements_selector_model_1_m.jpg';
import supplementsSelectorModelTablet1 from 'assets/images/landingPages/supplements/supplements_selector_model_1_t.jpg';
import supplementsSelectorModelDesktop2 from 'assets/images/landingPages/supplements/supplements_selector_model_2_d.jpg';
import supplementsSelectorModelMobile2 from 'assets/images/landingPages/supplements/supplements_selector_model_2_m.jpg';
import supplementsSelectorModelTablet2 from 'assets/images/landingPages/supplements/supplements_selector_model_2_t.jpg';
import supplementsSelectorModelDesktop3 from 'assets/images/landingPages/supplements/supplements_selector_model_3_d.jpg';
import supplementsSelectorModelMobile3 from 'assets/images/landingPages/supplements/supplements_selector_model_3_m.jpg';
import supplementsSelectorModelTablet3 from 'assets/images/landingPages/supplements/supplements_selector_model_3_t.jpg';
import supplementsRootSourceTablet1 from 'assets/images/landingPages/supplements/t-supplements_rootsource_1_hero.jpg';
import supplementsRootSourceTablet2 from 'assets/images/landingPages/supplements/t-supplements_rootsource_2_hero.jpg';
import supplementsBlog3 from 'assets/images/productPages/supp_blog_card_3.jpg';

import getEnv from 'utils/getEnv';
import getMediaUrl from 'utils/getMediaUrl';

const colorNoir = 'noir';
const colorWhite = 'white';

const titleHero = (
  <>
    reduce shedding & spark growth in 90 days<sup>*</sup>
  </>
);

export const titleHeroPostPartum = (
  <>
    reduce postpartum shedding in 90 days<sup>*</sup>
  </>
);
const titleCtaHero = 'get custom supplements';
const titlePart1Hero = 'Introducing';
const titlePart2Hero = 'Root Source';
const titleTMHero = '®';
const titlePart2ArrHero = titlePart2Hero.split(' ');
const titlePart3Hero = 'custom hair';
const titlePart4Hero = 'supplements';

export const cta = titleCtaHero;

export const getModuleHero = () => {
  const mediaRootUrl = getEnv('REACT_APP_MEDIA_ROOT_URL');
  const supplementsVideo3Desktop = `${mediaRootUrl}d-60plus.mp4`;
  const supplementsVideo3Mobile = `${mediaRootUrl}m-60plus.mp4`;
  const supplementsVideo3Tablet = `${mediaRootUrl}t-60plus.mp4`;
  const supplementsVideoStraightDesktop = `${mediaRootUrl}d-straight.mp4`;
  const supplementsVideoStraightMobile = `${mediaRootUrl}m-straight.mp4`;
  const supplementsVideoStraightTablet = `${mediaRootUrl}t-straight2.mp4`;
  const supplementsVideoCurlyDesktop = `${mediaRootUrl}d-curly.mp4`;
  const supplementsVideoCurlyMobile = `${mediaRootUrl}m-curly.mp4`;
  const supplementsVideoCurlyTablet = `${mediaRootUrl}t-curly3.mp4`;
  const supplementsPPDesktop = `${mediaRootUrl}postpartum-desktop.mp4`;
  const supplementsPPMobile = `${mediaRootUrl}postpartum-mobile.mp4`;
  const supplementsPPTablet = `${mediaRootUrl}postpartum-tablet.mp4`;

  return {
    title: titleHero,
    paragraphMobile: (
      <>
        {titlePart1Hero}{' '}
        <b>
          {titlePart2ArrHero[0]} <span id="hero-title-1">{titlePart2ArrHero[1]}</span>
        </b>{' '}
        {titlePart3Hero} {titlePart4Hero}
      </>
    ),
    paragraphDesktop: (
      <>
        <span>{titlePart1Hero}</span>
        <span>
          <b id="hero-title-1">
            {titlePart2Hero}
            <sup>{titleTMHero}</sup>
          </b>
        </span>
        <span>{titlePart3Hero}</span>
        <span>{titlePart4Hero}</span>
      </>
    ),
    variant: {
      default: {
        image: {
          desktop: { url: supplementsHeroDesktop, color: colorNoir },
          mobile: { url: supplementsHeroMobile, color: colorNoir },
          tablet: { url: supplementsHeroTablet, color: colorNoir },
        },
      },
      rootsource1: {
        image: {
          desktop: { url: supplementsRootSourceDesktop1, color: colorWhite },
          mobile: { url: supplementsRootSourceMobile1, color: colorWhite },
          tablet: { url: supplementsRootSourceTablet1, color: colorWhite },
        },
      },
      rootsource2: {
        image: {
          desktop: { url: supplementsRootSourceDesktop2, color: colorNoir },
          mobile: { url: supplementsRootSourceMobile2, color: colorNoir },
          tablet: { url: supplementsRootSourceTablet2, color: colorNoir },
        },
      },
      videostraight: {
        video: {
          desktop: { url: supplementsVideoStraightDesktop, color: colorNoir },
          mobile: { url: supplementsVideoStraightMobile, color: colorWhite },
          tablet: { url: supplementsVideoStraightTablet, color: colorNoir },
        },
      },
      videocurly: {
        video: {
          desktop: { url: supplementsVideoCurlyDesktop, color: colorNoir },
          mobile: { url: supplementsVideoCurlyMobile, color: colorWhite },
          tablet: { url: supplementsVideoCurlyTablet, color: colorWhite },
        },
      },
      video3: {
        video: {
          desktop: { url: supplementsVideo3Desktop, color: colorNoir },
          mobile: { url: supplementsVideo3Mobile, color: colorWhite },
          tablet: { url: supplementsVideo3Tablet, color: colorNoir },
        },
      },
      postpartum: {
        video: {
          desktop: { url: supplementsPPDesktop, color: colorWhite },
          mobile: { url: supplementsPPMobile, color: colorWhite },
          tablet: { url: supplementsPPTablet, color: colorWhite },
        },
      },
    },
  };
};
export const moduleFormula = {
  title: (
    <>
      Root Source<sup>®</sup> Custom Hair Supplements
    </>
  ),
  paragraph:
    'Our plant-based hair supplements are customized to help you grow your best hair with 2 daily capsules, taken together, to target scalp & hair.',
  prices: [{ formula: 'Subscribe & save' }, { formula: 'Buy once' }],
  info: [
    'Every order contains a 30-day supply of 2 capsules (60 capsules total). Take one of each capsule, with water, per day.',
  ],
  image: {
    desktop: supplementsFormulaDesktop,
    mobile: supplementsFormulaMobile,
    tablet: supplementsFormulaTablet,
  },
};
export const moduleCapsule = {
  title: 'Renew hair and scalp with 2 targeted capsules',
  circle: supplementsCapsuleCircle,
  body: [
    {
      capsule: 'Capsule',
      number: '01',
      info: 'For scalp balance',
      description:
        'Customized for you with a blend of ingredients known to rebalance scalp, tame oiliness, nourish dryness, soothe sensitivity, protect against pollution, or shield from the effects of stress.',
      image1: {
        desktop: supplementsCapsuleDesktop1,
        mobile: supplementsCapsuleMobile1,
        alt: 'Overhead photo of a woman looking down, showing her scalp with locks on light blue beige background',
      },
      image2: {
        desktop: supplementsCapsuleDesktop2,
        mobile: supplementsCapsuleMobile2,
        alt: 'Woman photopraphed from the side holding a supplement pill about to put it in her mouth on light blue beige background',
      },
    },
    {
      capsule: 'Capsule',
      number: '02',
      info: 'For super growth',
      description: (
        <>
          Our proprietary blend PureCatalyst<sup id="pure-catalyst-tm">TM</sup> stimulates the hair
          bulb to grow faster and hold tighter, meaning less shedding.<sup>****</sup>
        </>
      ),
      legend: {
        text: '****Ex Vivo studies on millet extract.',
        linkText: 'See study',
        linkPdf: getMediaUrl('supplements_clinical_study.pdf'),
      },
      cta: true,
      image1: {
        desktop: supplementsCapsuleDesktop3,
        mobile: supplementsCapsuleMobile3,
        alt: 'Hand with red nail polish holding a supplement pill in the air on a beige background',
      },
      image2: {
        desktop: supplementsCapsuleDesktop4,
        mobile: supplementsCapsuleMobile4,
        alt: 'Woman with red sweater and beautiful and wavy white hair photographed from behind on beige background',
      },
    },
  ],
};
export const moduleClinical = {
  title: 'Tried, tested, and shown effective',
  paragraph:
    'In rigorous clinical testing and in-house studies, participants saw remarkable results over 90 days:',
  statistics: [
    {
      number: '93%',
      info: (
        <>
          <span>saw improved</span>
          <span>
            hair growth<sup>***</sup>
          </span>
        </>
      ),
    },
    {
      number: '91%',
      info: (
        <>
          <span>saw reduced</span>
          <span>
            hair loss<sup>**</sup>
          </span>
        </>
      ),
    },
    {
      number: '90%',
      info: (
        <>
          <span>saw reduced</span>
          <span>
            hair breakage<sup>***</sup>
          </span>
        </>
      ),
    },
    {
      number: '90%',
      info: (
        <>
          <span>saw improved</span>
          <span>
            hair appearance<sup>***</sup>
          </span>
        </>
      ),
    },
    {
      number: '83%',
      info: (
        <>
          <span>saw improved</span>
          <span>
            hair shine<sup>***</sup>
          </span>
        </>
      ),
    },
    {
      number: '75%',
      info: (
        <>
          <span>saw improved</span>
          <span>
            hair brightness & softness<sup>**</sup>
          </span>
        </>
      ),
    },
  ],
  legends: [
    {
      text: '** Double blind clinical study vs. placebo related to our proprietary blend performed on 60 subjects during 12 weeks.',
      linkText: 'See full clinical study',
      linkPdf: getMediaUrl('supplements_clinical_study.pdf'),
    },
    {
      text: (
        <>
          *** Results of a 3-month in-house study of Prose 2-step hair growth program performed on
          69 subjects. <em>Results may vary.</em>
        </>
      ),
      linkText: 'See full in-house study',
      linkPdf: getMediaUrl('supplements_inhouse_study.pdf'),
    },
  ],
  image: {
    desktop: supplementsClinicalDesktop,
    mobile: supplementsClinicalMobile,
    tablet: supplementsClinicalTablet,
  },
  title2: 'Visible results in 90 days',
  paragraph2: (
    <>
      Taken daily, our supplements can help fill in sparse parts and hairlines, as demonstrated by
      these Prose team member results.<sup>†</sup>
    </>
  ),
  legend: (
    <>
      † Photo taken by one Root Source<sup>®</sup> participant after 1 month and after 3 months of
      daily use with Root Source<sup>®</sup> Capsule 1 and Capsule 2 - Results may vary.
    </>
  ),
};
export const moduleSelector = {
  title: 'Made with natural, clean, safe ingredients',
  paragraph: (
    <>
      Root Source<sup>®</sup> helps hair grow naturally with sustainably-grown ingredients. While
      your specific ingredients will vary depending on your custom needs, everyone’s supplements
      include our proprietary blend PureCatalyst<sup>TM</sup> that boosts growth with millet,
      coriander oil, and gluten-free wheat oil.
    </>
  ),
  link: {
    text: 'Discover yours',
    url: '/consultation/haircare',
  },
  ingredients: [
    {
      name: 'Millet',
      description:
        'Sourced from French valleys with sustainable, eco-friendly harvesting, millet’s key active, millacin, is clinically proven to stimulate the follicle and anchor the root tightly in the scalp.',
      imageBackground: {
        desktop: supplementsSelectorBackgroundDesktop1,
        mobile: supplementsSelectorBackgroundMobile1,
        tablet: supplementsSelectorBackgroundTablet1,
      },
      imageModel: {
        desktop: supplementsSelectorModelDesktop1,
        mobile: supplementsSelectorModelMobile1,
        tablet: supplementsSelectorModelTablet1,
        alt: 'Blong wavy haired woman similing holding a few pieces of millet in front of her face on beige background',
      },
      imageSelector: {
        allDevice: supplementsSelector1,
        alt: 'Close up picture of wheat oil plant on beige background',
      },
      link: {
        text: 'More about millet',
        url: '/ingredients/hair-supplements-millet-seed-extract',
      },
    },
    {
      name: 'Wheat oil',
      description:
        'Naturally rich in phytoceramides, our gluten-free wheat oil is known to nourish the scalp and helps prompt cell renewal to regenerate skin’s protective barrier.',
      imageBackground: {
        desktop: supplementsSelectorBackgroundDesktop2,
        mobile: supplementsSelectorBackgroundMobile2,
        tablet: supplementsSelectorBackgroundTablet2,
      },
      imageModel: {
        desktop: supplementsSelectorModelDesktop2,
        mobile: supplementsSelectorModelMobile2,
        tablet: supplementsSelectorModelTablet2,
        alt: 'Three pieces of wheat oil on a brunette straight haired woman photographed from behind',
      },
      imageSelector: {
        allDevice: supplementsSelector2,
        alt: 'Coriander oil photographed on beige background',
      },
      link: {
        text: 'More about wheat oil',
        url: '/ingredients/hair-supplements-wheat-oil',
      },
    },
    {
      name: 'Coriander oil',
      description:
        'Rich in omega-12 fatty acids, this oil is known to help fortify skin, making your scalp stronger and less sensitive –a great place to put down roots.',
      imageBackground: {
        desktop: supplementsSelectorBackgroundDesktop3,
        mobile: supplementsSelectorBackgroundMobile3,
        tablet: supplementsSelectorBackgroundTablet3,
      },
      imageModel: {
        desktop: supplementsSelectorModelDesktop3,
        mobile: supplementsSelectorModelMobile3,
        tablet: supplementsSelectorModelTablet3,
        alt: 'Corinader oil bouquet in front of brunette woman with curly hair looking up',
      },
      imageSelector: {
        allDevice: supplementsSelector3,
        alt: 'Photography of millet plant on a white background',
      },
      link: {
        text: 'More about coriander oil',
        url: '/ingredients/hair-supplements-coriander-seed-oil',
      },
    },
  ],
};
export const moduleIngredients = {
  title: 'Compare with other hair-growth ingredients',
  paragraph:
    'Unlike other hair-growth options on the market, our supplements are safe, natural, and effective all at once—no compromises or sacrifices.',
  logo: supplementsProseLogo,
  ingredients: {
    header: ['', 'prose', 'other brands'],
    body: [
      ['Active Ingredient', 'Millet', 'Minoxidil', 'Finasteride', 'Saw Palmetto'],
      ['Clinically effective to reduce hair loss', true, true, true, true],
      ['Non-drug ingredients', true, false, false, true],
      ['100% natural ingredient', true, false, false, true],
      ['Does not target DHT hormones', true, true, false, false],
      ['Known to increase hair bulb anchorage', true, false, false, false],
    ] as const,
    bodySearchTraffic: [
      ['Active Ingredient', 'Millet', 'Minoxidil', 'Saw Palmetto'],
      ['Clinically effective to reduce hair loss', true, true, true],
      ['Non-drug ingredients', true, false, true],
      ['100% natural ingredient', true, false, true],
      ['Does not target DHT hormones', true, true, false],
      ['Known to increase hair bulb anchorage', true, false, false],
    ] as const,
  },
};
export const moduleScrollingText = {
  paragraph:
    'No soy, nuts, gluten, or GMOs. No synthetic fillers or additives. No artificial flavors or colors.',
  image: {
    desktop: supplementsScrollingTextDesktop,
    mobile: supplementsScrollingTextMobile,
    tablet: supplementsScrollingTextTablet,
  },
};
export const moduleTestimonials = {
  title: 'Over time, hair not only grows—it blooms',
  paragraph:
    'You’ll notice stronger, softer hair take root in a few weeks, and see dramatic changes unfold after that. In six months, you’ll be inches into the best hair of your life—with no end in sight.',
  steps: [
    {
      date: 'Day 30',
      testimonial: '“I feel like my hair is less frizzy and smoother.”',
      author: '- Talia B., Type 4A: Coily, in her 30s',
    },
    {
      date: 'Day 60',
      testimonial: '“My hair has taken off! Everyone comments on how long my hair is getting.”',
      author: '- Kendra M., Type 1: Straight, in her 40s',
    },
    {
      date: 'Day 90 & beyond',
      testimonial: '“My hair is much fuller at the root, and I have much less breakage.”',
      author: '- Beth M., Type 2:  Wavy or Loose Curl, in her 20s',
    },
  ],
  info: (
    <>
      <em>Results may vary from one individual to another</em>. Testimonials from real Prose
      customers given{' '}
      <b>
        Root Source<sup>®</sup>
      </b>{' '}
      to test pre-launch.
    </>
  ),
};
export const moduleCloudyPill = {
  title: 'Transparently natural',
  paragraph:
    'Since we use no synthetic fillers, dyes, or coatings on our capsules, the ingredients inside can sometimes naturally separate and appear ‘cloudy’—this is 100% normal and doesn’t affect the formulas’ freshness & potency.',
  image: {
    desktop: supplementsCloudyPillDesktop,
    mobile: supplementsCloudyPillMobile,
    tablet: supplementsCloudyPillTablet,
  },
};
export const moduleFullRoutine = {
  title: 'How Prose Works',
  paragraph: '',
  steps: [
    {
      step: 'Take the consultation',
      info: 'We analyze over 85 factors to find what your hair truly needs.',
      icon: 'consultation',
    },
    {
      step: 'Discover your ideal routine',
      info: 'Customize your entire hair routine from shampoo to supplements.',
      icon: 'routine',
    },
    {
      step: 'Subscribe & Save',
      info: 'Subscribe to save 15% + unlock free shipping.',
      icon: 'subscribe',
    },
  ] as const,
  cta: 'Get your Prose',
  image: {
    desktop: supplementsFullRoutineDesktop,
    mobile: supplementsFullRoutineMobile,
    tablet: supplementsFullRoutineTablet,
  },
};
export const moduleBigHands = {
  paragraphs: [
    'No soy, nuts, gluten, or GMOs. No synthetic fillers or additives. No artificial flavors or colors. No drug ingredients or hormone disruptors. Toxicologist-approved.',
    'Dermatologist-approved. Sustainable, traceable ingredients. Vegan & cruelty-free. Globally sourced, customized in the USA.',
  ],
  image: {
    desktop: supplementsBigHandsDesktop,
    mobile: supplementsBigHandsMobile,
    tablet: supplementsBigHandsTablet,
  },
};
export const faq = {
  title: 'Frequently asked questions',
  questions: [
    {
      question: (
        <>
          Why are there two separate Root Source<sup>®</sup> capsules? Do I have to take both?
        </>
      ),
      answer: (
        <>
          <b>Root Source</b>
          <sup>®</sup> is a two-capsule system designed to work holistically to deliver hair
          renewal & growth at the source. Capsule 1 lays the foundation with a customized blend of
          actives known to balance the scalp*. Capsule 2, containing our proprietary PureCatalyst™
          complex, stimulates the hair bulb for faster hair growth and decreased shedding*.
          <br />
          <br />
          To ensure the best results, <b>Root Source</b>
          <sup>®</sup> is only available for purchase as a two-capsule system.
        </>
      ),
    },
    {
      question: (
        <>
          How should I take my Root Source<sup>®</sup> supplements?
        </>
      ),
      answer: (
        <>
          Take your two <b>Root Source</b>
          <sup>®</sup> capsules once a day, with food if you have a sensitive stomach. Consistency
          is key, so aim to take daily without skipping any doses.
        </>
      ),
    },
    {
      question: (
        <>
          My Root Source<sup>®</sup> capsules look a bit cloudy—is this normal?
        </>
      ),
      answer: (
        <>
          Totally normal—<b>Root Source</b>
          <sup>®</sup> is made without any synthetic fillers or dyes, so what you’re seeing is
          natural. The actives may separate into their crystalline forms, making spots of the
          capsule appear cloudy, but this has no impact on the formulas’ freshness or potency.
        </>
      ),
    },
    {
      question: 'When can I expect to see results?',
      answer: (
        <>
          Within a few weeks of use, your scalp should feel more balanced and hair should start
          feeling softer and stronger. After three months of use, you may notice new baby hairs
          forming; stay committed, and after six months you’ll continue to see the results of new
          hair growth*. <em>Results may vary</em>.
          <br />
          <br />
          If for any reason you’re not completely satisfied with the results of your{' '}
          <b>Root Source</b>
          <sup>®</sup> supplements, you can <a href="https://prose.com/faq">contact The Pros</a>.
        </>
      ),
    },
    {
      question: (
        <>
          Will Root Source<sup>®</sup> supplements meet my Prose ingredient preferences? What if I
          have an ingredient concern?
        </>
      ),
      answer: (
        <>
          All <b>Root Source</b>
          <sup>®</sup> supplements are vegan, cruelty-free, and gluten-free through the use of
          gluten-free wheat extract. In addition, they are free of the following: soy, nuts, GMOs,
          hormone disruptors, synthetic fillers, artificial flavors, and artificial coloring.
          <br />
          <br />
          You can view a full list of your <b>Root Source</b>
          <sup>®</sup> ingredients in your shopping cart before checkout, but please note that we
          cannot add or remove ingredients from your formulas. If pregnant, nursing, having a health
          condition or taking medication, please consult with your doctor before taking{' '}
          <b>Root Source</b>
          <sup>®</sup>.
        </>
      ),
    },
    {
      question: (
        <>
          What are Root Source<sup>®</sup> refill pouches, and why should I hold onto my first set
          of jars?
        </>
      ),
      answer: (
        <>
          Your first set of <b>Root Source</b>
          <sup>®</sup> will arrive in refillable glass jars. All subsequent orders (whether
          subscription or one-off) will arrive in refill pouches. These pouches are 100%
          compostable, and allow for a significantly lower{' '}
          <a href="https://prose.com/sustainability-and-social-impact">carbon footprint</a>.
          <br />
          <br />
          Hold onto your original glass jars, and they’ll be endlessly refillable. For any
          questions, just contact The Pros <a href="https://prose.com/contact">here</a>.
        </>
      ),
    },
  ],
  preSupplementsRefillPouchesQuestions: [
    {
      question: (
        <>
          Why are there two separate Root Source<sup>®</sup> capsules? Do I have to take both?
        </>
      ),
      answer: (
        <>
          <b>Root Source</b>
          <sup>®</sup> is a two-capsule system designed to work holistically to deliver hair
          renewal & growth at the source. Capsule 1 lays the foundation with a customized blend of
          actives known to balance the scalp*. Capsule 2, containing our proprietary PureCatalyst™
          complex, stimulates the hair bulb for faster hair growth and decreased shedding*.
          <br />
          <br />
          To ensure the best results, <b>Root Source</b>
          <sup>®</sup> is only available for purchase as a two-capsule system.
        </>
      ),
    },
    {
      question: (
        <>
          How should I take my Root Source<sup>®</sup> supplements?
        </>
      ),
      answer: (
        <>
          Take your two <b>Root Source</b>
          <sup>®</sup> capsules once a day, with food if you have a sensitive stomach. Consistency
          is key, so aim to take daily without skipping any doses.
        </>
      ),
    },
    {
      question: (
        <>
          My Root Source<sup>®</sup> capsules look a bit cloudy—is this normal?
        </>
      ),
      answer: (
        <>
          Totally normal—<b>Root Source</b>
          <sup>®</sup> is made without any synthetic fillers or dyes, so what you’re seeing is
          natural. The actives may separate into their crystalline forms, making spots of the
          capsule appear cloudy, but this has no impact on the formulas’ freshness or potency.
        </>
      ),
    },
    {
      question: 'When can I expect to see results?',
      answer: (
        <>
          Within a few weeks of use, your scalp should feel more balanced and hair should start
          feeling softer and stronger. After three months of use, you may notice new baby hairs
          forming; stay committed, and after six months you’ll continue to see the results of new
          hair growth*. <em>Results may vary</em>.
          <br />
          <br />
          If for any reason you’re not completely satisfied with the results of your{' '}
          <b>Root Source</b>
          <sup>®</sup> supplements, you can <a href="https://prose.com/faq">contact The Pros</a>.
        </>
      ),
    },
    {
      question: (
        <>
          Will Root Source<sup>®</sup> supplements meet my Prose ingredient preferences? What if I
          have an ingredient concern?
        </>
      ),
      answer: (
        <>
          All <b>Root Source</b>
          <sup>®</sup> supplements are vegan, cruelty-free, and gluten-free through the use of
          gluten-free wheat extract. In addition, they are free of the following: soy, nuts, GMOs,
          hormone disruptors, synthetic fillers, artificial flavors, and artificial coloring.
          <br />
          <br />
          You can view a full list of your <b>Root Source</b>
          <sup>®</sup> ingredients in your shopping cart before checkout, but please note that we
          cannot add or remove ingredients from your formulas. If pregnant, nursing, having a health
          condition or taking medication, please consult with your doctor before taking{' '}
          <b>Root Source</b>
          <sup>®</sup>.
        </>
      ),
    },
    {
      question: (
        <>
          Can I place a one-time order for Root Source<sup>®</sup>? Do I have to subscribe to this
          product?
        </>
      ),
      answer: (
        <>
          The choice is yours—you can place one-time orders for a 30-day supply of{' '}
          <b>Root Source</b>
          <sup>®</sup>, or you can subscribe at a monthly cadence. By subscribing to{' '}
          <b>Root Source</b>
          <sup>®</sup>, you’ll enjoy 15% off each refill along with all of our exclusive membership
          perks.
          <br />
          <br />
          If you’re an existing Salon member, you can add <b>Root Source</b>
          <sup>®</sup> to your next refill through your subscription page.
        </>
      ),
    },
  ],
};
export const blog = {
  title: 'THE PROSE BLOG',
  subtitle:
    'Step up your healthy hair care routine with tips and advice from our in-house experts.',
  content: [
    {
      image: supplementsBlog1,
      category: 'From Prose',
      title: 'Our Head of R&D on Why Your Supplements Should be Customized',
      subtitle: 'Meet your match.',
      url: 'https://prose.com/blog/why-customize-hair-supplements-prose.php',
    },
    {
      image: supplementsBlog2,
      category: 'Hair health',
      title: 'How Millet Seed Extract Can Help Grow Your Hair to New Lengths',
      subtitle: 'Boost your roots.',
      url: 'https://prose.com/blog/millet-seed-extract.php',
    },
    {
      image: supplementsBlog3,
      category: 'From Prose',
      title: (
        <>
          Root Source<sup>®</sup> Gets a Sustainable Upgrade with New Refill Pouches
        </>
      ),
      subtitle: 'Break it down.',
      url: 'https://prose.com/blog/supplements-refills-prose.php',
    },
  ],
};
